import { render, staticRenderFns } from "./ServicesReservationAdd.vue?vue&type=template&id=222c014e&scoped=true&"
import script from "./ServicesReservationAdd.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c014e",
  null
  
)

export default component.exports